"use client";

import { motion, useReducedMotion } from "framer-motion";
import { MapPin, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function Cobertura() {
  const prefersReducedMotion = useReducedMotion();
  const cities = [{
    name: "Totana",
    region: "Sede Central & Valle del Guadalentín",
    description: "Atención técnica inmediata, diagnóstico de fugas y mantenimiento integral con base operativa local.",
    path: "/TotanaPage",
    tag: "Sede Principal"
  }, {
    name: "Murcia",
    region: "Capital & Área Metropolitana",
    description: "Servicios urgentes y programados de fontanería, climatización y reformas para viviendas y comunidades.",
    path: "/MurciaPage",
    tag: "Cobertura Completa"
  }, {
    name: "Alicante",
    region: "Costa Blanca & Provincia",
    description: "Especialistas en detección no invasiva de fugas, piscinas y climatización para clientes residenciales e internacionales.",
    path: "/AlicantePage",
    tag: "Zona Costa"
  }, {
    name: "Almería",
    region: "Levante Almeriense & Provincia",
    description: "Asistencia profesional, reformas integrales y mantenimiento preventivo para inmuebles y complejos residenciales.",
    path: "/AlmeriaPage",
    tag: "Zona Levante"
  }];
  const containerVariants = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: prefersReducedMotion ? 0 : 0.08
      }
    }
  };
  const itemVariants = {
    hidden: prefersReducedMotion ? {
      opacity: 0
    } : {
      opacity: 0,
      y: 16
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: [0.2, 0.6, 0.2, 1] as [number, number, number, number]
      }
    }
  };
  return <section data-section-id="32642" id="cobertura-en-el-sureste-español" data-nav="light" className="bg-background text-foreground py-20 sm:py-28 relative overflow-hidden">
      <div className="max-w-[1360px] mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.2
      }}>
          {}
          <motion.div variants={itemVariants} className="flex items-center gap-2 mb-3">
            <span aria-hidden="true" className="inline-block w-[1.5px] h-3 bg-primary" />
            <span className="font-sans font-semibold text-xs tracking-[0.22em] uppercase text-primary">
              Área de Actuación
            </span>
            <span aria-hidden="true" className="inline-block w-[1.5px] h-3 bg-primary" />
          </motion.div>

          {}
          <motion.h2 variants={itemVariants} className="font-default font-extrabold uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tight text-foreground">
            Zonas de cobertura
          </motion.h2>

          {}
          <motion.p variants={itemVariants} className="mt-4 text-muted-foreground text-base sm:text-lg max-w-2xl leading-relaxed">
            Prestamos asistencia técnica especializada en fontanería, detección de fugas, climatización, piscinas y reformas en los principales núcleos del sureste peninsular.
          </motion.p>

          {}
          <motion.div variants={containerVariants} className="mt-10 sm:mt-12 grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
            {cities.map((city, i) => <motion.div key={city.name} data-index={i} variants={itemVariants}>
                <Link to={city.path} className="group relative flex flex-col justify-between p-6 sm:p-8 rounded-2xl bg-card border border-border/80 shadow-sm hover:shadow-md hover:border-primary/50 transition-all duration-300 h-full">
                  <div>
                    <div className="flex items-center justify-between gap-4 mb-4">
                      <div className="flex items-center gap-3">
                        <div className="p-3 rounded-xl bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                          <MapPin className="w-6 h-6 shrink-0" />
                        </div>
                        <div>
                          <h3 className="font-default font-bold text-2xl uppercase tracking-tight text-foreground group-hover:text-primary transition-colors">
                            {city.name}
                          </h3>
                          <span className="text-xs font-medium text-muted-foreground uppercase tracking-wider block mt-0.5">
                            {city.region}
                          </span>
                        </div>
                      </div>
                      <span className="shrink-0 text-xs font-semibold px-3 py-1 rounded-lg bg-muted text-muted-foreground group-hover:bg-primary/10 group-hover:text-primary transition-colors">
                        {city.tag}
                      </span>
                    </div>

                    <p className="text-muted-foreground text-sm leading-relaxed mb-6">
                      {city.description}
                    </p>
                  </div>

                  <div className="flex items-center text-sm font-semibold text-primary group-hover:translate-x-1.5 transition-transform duration-200 pt-2 border-t border-border/40">
                    <span>Ver servicios en {city.name}</span>
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </div>
                </Link>
              </motion.div>)}
          </motion.div>
        </motion.div>
      </div>
    </section>;
}